/**
 * @file automatically generated from MApp.Data.MapInterpretationType
 */

export enum MapInterpretationType {
    Default = 0,
    Dimensioning = 1,
    TrafficNetwork = 2,
    HeatMap = 3,
    ClusterPoint = 4
}
